import { Injectable, signal } from '@angular/core';

/** Drives the soft sign-up nudge shown when a guest tries to save an item
 * or buy — encourages account creation without hard-gating browsing. */
@Injectable({ providedIn: 'root' })
export class SignupPromptService {
  readonly message = signal<string | null>(null);

  show(message: string): void {
    this.message.set(message);
  }

  hide(): void {
    this.message.set(null);
  }
}
